import React from "react"
import "./styles.css"

import warriorLogo from "../../../assets/warrior-logo.png"
import crusaderLogo from "../../../assets/crusader-logo.png"
import shooterLogo from "../../../assets/shooter-logo.png"
import dualgunnerLogo from "../../../assets/dualgunner-logo.png"
import warlockLogo from "../../../assets/warlock-logo.png"
import priestLogo from "../../../assets/priest-logo.png"

const ClassContainer = (props) => {
    const { imgId, handleClickClassOrResetBuild } = props
    return (
        <div className="class-container">
            <img
                id="imgClass"
                className={imgId}
                src={warriorLogo}
                alt="gladiador"
                onClick={handleClickClassOrResetBuild}
            />

            <img
                id="imgClass"
                className={imgId}
                src={shooterLogo}
                alt="dinamitador"
                onClick={handleClickClassOrResetBuild}
            />

            <img
                id="imgClass"
                className={imgId}
                src={warlockLogo}
                alt="feiticeiro"
                onClick={handleClickClassOrResetBuild}
            />

            <img
                id="imgClass"
                className={imgId}
                src={crusaderLogo}
                alt="paladino"
                onClick={handleClickClassOrResetBuild}
            />

            <img
                id="imgClass"
                className={imgId}
                src={dualgunnerLogo}
                alt="desperado"
                onClick={handleClickClassOrResetBuild}
            />

            <img
                id="imgClass"
                className={imgId}
                src={priestLogo}
                alt="santo"
                onClick={handleClickClassOrResetBuild}
            />
        </div>
    )
}

export default ClassContainer
